// extracted by mini-css-extract-plugin
export var block = "Faq-module--block--0a386";
export var content = "Faq-module--content--30384";
export var inner = "Faq-module--inner--2b1ec";
export var isCollapsed = "Faq-module--isCollapsed--1246b";
export var wrapper = "Faq-module--wrapper--5ccb9";